import api from './api';

export const inventoryService = {
  // Vehicle Inventory
  getVehicles: async (params = {}) => {
    const response = await api.get('/v1/inventory/vehicles/', { params });
    return response.data;
  },

  getVehicle: async (id) => {
    const response = await api.get(`/v1/inventory/vehicles/${id}/`);
    return response.data;
  },

  createVehicle: async (vehicleData) => {
    const response = await api.post('/v1/inventory/vehicles/', vehicleData);
    return response.data;
  },

  updateVehicle: async (id, vehicleData) => {
    const response = await api.put(`/v1/inventory/vehicles/${id}/`, vehicleData);
    return response.data;
  },

  deleteVehicle: async (id) => {
    const response = await api.delete(`/v1/inventory/vehicles/${id}/`);
    return response.data;
  },

  // Get inventory statistics
  getInventoryStats: async () => {
    const response = await api.get('/v1/inventory/vehicles/stats/');
    return response.data;
  },

  // Get available vehicles only
  getAvailableVehicles: async () => {
    const response = await api.get('/v1/inventory/vehicles/available/');
    return response.data;
  },

  // Service Appointments
  getServiceAppointments: async (params = {}) => {
    const response = await api.get('/v1/inventory/service-appointments/', { params });
    return response.data;
  },

  getServiceAppointment: async (id) => {
    const response = await api.get(`/v1/inventory/service-appointments/${id}/`);
    return response.data;
  },

  createServiceAppointment: async (appointmentData) => {
    const response = await api.post('/v1/inventory/service-appointments/', appointmentData);
    return response.data;
  },

  updateServiceAppointment: async (id, appointmentData) => {
    const response = await api.put(`/v1/inventory/service-appointments/${id}/`, appointmentData);
    return response.data;
  },

  deleteServiceAppointment: async (id) => {
    const response = await api.delete(`/v1/inventory/service-appointments/${id}/`);
    return response.data;
  },

  // Complete a service appointment
  completeServiceAppointment: async (id, completionData) => {
    const response = await api.post(`/v1/inventory/service-appointments/${id}/complete/`, completionData);
    return response.data;
  },

  // Get today's service appointments
  getTodayAppointments: async () => {
    const response = await api.get('/v1/inventory/service-appointments/today/');
    return response.data;
  },

  // Service History
  getServiceHistory: async (params = {}) => {
    const response = await api.get('/v1/inventory/service-history/', { params });
    return response.data;
  },

  getServiceHistoryRecord: async (id) => {
    const response = await api.get(`/v1/inventory/service-history/${id}/`);
    return response.data;
  },

  createServiceHistory: async (serviceData) => {
    const response = await api.post('/v1/inventory/service-history/', serviceData);
    return response.data;
  },

  updateServiceHistory: async (id, serviceData) => {
    const response = await api.put(`/v1/inventory/service-history/${id}/`, serviceData);
    return response.data;
  },

  deleteServiceHistory: async (id) => {
    const response = await api.delete(`/v1/inventory/service-history/${id}/`);
    return response.data;
  },
};